import React from "react";
import Loader from 'react-loader-spinner'
import FilterModal from "../../modals/FilterModal";
import { getBoundingClientRect } from "../../utils/functions";
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, getObject, imageAddress, paramToStandardOption, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import StagesManager from "../StagesManager";
import ParamsListItems from "./ParamsListItems";
// import FilterViewer from "../FilterViewer";
// import FilterModal from '../modals/FilterModal';
// import Modal from "../Modal";


class GlobalUserInput extends React.Component {

    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        editMode: false,
        // lastNewId: 0,
        search: ''

    }

    toggleOpen = (open) => {
        // console.log("HERE")
        let disabled = this.props.header?.information?.disabled
        if (!disabled) {
            let openState = open != null ? open : !this.state.isOpen

            if (openState) {
                this.fixedView.showView()
            } else {
                this.fixedView.hideView()
            }

            this.setState({ isOpen: openState, data: this.props.data })
        }

    }


    // toggleOpen = (open) => {
    //     // console.log("HERE")
    //     let openState = open != null ? open : !this.state.isOpen

    //     if (openState) {
    //         document.addEventListener('mousedown', this.closeBox);
    //         window.addEventListener('scroll', this.getPosition, true);
    //         this.getPosition()

    //     } else {
    //         document.removeEventListener('mousedown', this.closeBox);
    //         window.removeEventListener('scroll', this.getPosition);
    //     }
    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: openState, data: this.props.data })

    // }

    // openBox = () => {

    //     if (!this.state.isOpen) {
    //         document.addEventListener('mousedown', this.closeBox);
    //     }
    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: true, data: this.props.data })

    // }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

            // this.refs.icon.classList.toggle("rotate-180")

        }
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        let indicatorBound = getBoundingClientRect(this.positionIndicator)


        let windowTop = indicatorBound.top > 0 ? indicatorBound.top : 0

        let spaceFromBottom = window.innerHeight - rect.top - windowTop - 35
        let spaceFromTop = rect.top + windowTop



        let top = rect.top - indicatorBound.top
        let left = rect.left - indicatorBound.left
        let maxHeight = 300

        if (spaceFromBottom < maxHeight) {
            if (spaceFromBottom < spaceFromTop) {

                // if (spaceFromTop - 10 > maxHeight) {
                maxHeight = spaceFromTop > maxHeight ? maxHeight : (spaceFromTop - 10)
                // }
                top = top - maxHeight - 8
            } else {
                top = top + 35
                maxHeight = spaceFromBottom - 10
            }
        } else {
            top = top + 35
        }
        this.setState({ top: top, left: left - 10, maxHeight }, () => {
            // let listBound = getBoundingClientRect(this.listView)

            // console.log(window.innerHeight - top-35)
            // console.log(listBound.height)
            // console.log((window.innerHeight - top - 35) < listBound.height)

            // if (window.innerHeight - top - 35 < listBound.height) {

            //     let maxHeight = 300

            //     if(top - listBound.height-7 > listBound.height){
            //          top = top - listBound.height

            //          console.log("TP1")
            //     }else{

            //         console.log("TP2")
            //         console.log((top + indicatorBound.top - 7))
            //         console.log((window.innerHeight - indicatorBound.top - top - 35))

            //         if((top + indicatorBound.top - 7) > (window.innerHeight - indicatorBound.top - top - 35)){

            //             console.log("TP3")
            //             top = top - listBound.height
            //             maxHeight = top - indicatorBound.top - 7

            //         }else{
            //             maxHeight = window.innerHeight - top - indicatorBound.top - 35
            //             console.log("TP4")
            //             top = top+35
            //         }

            //     }

            //     console.log("maxHeight")
            //     console.log(maxHeight)
            //     console.log(top)
            //     console.log(listBound.height)

            //     this.setState({top:top,maxHeight})
            //     // console.log(window.innerHeight - top)
            // }

        })
    }



    changeItem = (prop, selected, dontChangeValue) => {
        // console.log("changeItem")
        // console.log(prop)
        // var choosen = this.state.choosen
        this.setState({ title: '', search: '', choosen: prop }, () => {
            this.changeValue()
            if (this.state.tempData.length > 0)
                this.setState({ options: this.state.tempData })

            // if (this.refs.input)
            //     this.refs.input.focus()
        })


        // if (selected) {
        //     for (let i = 0; i < choosen.length; i++) {

        //         if (choosen[i].value == prop.value) {
        //             choosen.splice(i, 1)
        //         }
        //     }
        // } else {
        //     choosen.push(prop)
        // }

        // this.setState({ choosen }, () => {
        //     if (!dontChangeValue) 
        // })

        setTimeout(() => {
            this.toggleOpen(false)
        }, 1);

        // setTimeout(
        //     function () {
        //         this.toggleOpen()
        //     }
        //         .bind(this),
        //     1
        // );




        // this.changeFilter(prop.value)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentDidMount() {
        this.mounted = true
        // console.log(this.props.data)
        this.init()

    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.data)
        // console.log('prevProps', prevProps)
        // console.log('this.props', this.props)
        if (prevProps.data != this.props.data && this.mounted) {
            this.init()
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }


    init() {
        // console.log('USERINIT')

        if (this.props.header.information) {
            // if (this.props.header.information?.type == "local") {

            //     let options = []
            //     let choosen = []

            //     if (this.props.header.information?.items && this.props.header.information?.items.length > 0) {
            //         options = this.props.header.information?.items
            //     }

            //     if (this.props.title && Array.isArray(this.props.title)) {
            //         this.props.title.forEach(element => {
            //             choosen.push({ title: element, value: element })
            //         });
            //     }
            //     // console.log(this.props.title)
            //     this.setState({ options, choosen })
            // } else if ( this.props.header.information?.type == "api") {
            //     // console.log(this.props.title)
            this.fetch()
            // }
        }
    }


    fetch() {
        this.setState({ isLoading: true })
        let address = this.props.header.information?.address ?? "searchHub"
        let filter = this.props.header.information?.filter ? (typeof this.props.header.information?.filter == "string" ? JSON.parse(this.props.header.information?.filter) : this.props.header.information?.filter) : {}
        // console.log(filter)
        // console.log(filter)
        // console.log(this.props.variables)

        for (const [key, value] of Object.entries(filter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
                // console.log("VAR")
            }
        }
        // console.log(this.props.variables)

        // let fields = (this.props.header.information?.fields && Object.keys(this.props.header.information?.fields)?.length) ? this.props.header.information?.fields : { title: 'fullname', description: 'username', value: '_id', image: 'image' }

        // console.log(address, filter)


        HttpService.request(address, filter, (fetchResult, fetchError) => {


            this.setState({ isLoading: false })

            // console.log(fetchError)

            if (fetchError) { return }

            // console.log(fetchResult)
            // fetch(address, {
            //     method: 'POST',
            //     body: JSON.stringify(filter),
            //     headers: headers
            // }).then(response => response.json()).then(data => {
            // console.log(data)
            // if (data.status == 200 && this.mounted) {
            let newData = []
            let newParents = []

            fetchResult.info.sort((a, b) => { return a.values?.parent - b.values?.parent })


            fetchResult.info.forEach(element => {

                // let newTitle = getObject(element, fields.title)
                // let newValue = getObject(element, fields.value)
                // let newImage
                // let newDescription
                // if (fields.image) {
                //     newImage = getObject(element, fields.image)
                // }
                // if (fields.description) {
                //     newDescription = getObject(element, fields.description)
                // }
                // let parent = getObject(element, fields?.parent)
                let myData = {}
                let fields = this.props.header.information.fields ?? { title: 'fullname', value: '_id', image: 'image', username: 'username' }

                Object.entries(fields)?.map(([key, value]) => {
                    myData[key] = getObject(element, value)
                })


                // if (parent && parent != '') {
                if (myData) {
                    // newData.push({ value: newValue, title: newTitle, image: newImage, description: newDescription, parent: ((parent && typeof parent == 'object') ? parent._id : parent) })
                    newData.push(myData)
                }
                // } else {
                //     newParents.push({ value: newValue, title: newTitle,image:newImage, parent: (typeof parent == 'object' ? parent._id : parent) })
                // }

            });


            newParents.sort((a, b) => { return a.values?.name - b.values?.name })

            // console.log('/////////')
            // console.log(this.props.data)
            let userId
            if (this.props.data) {
                userId = typeof this.props.data == 'object' ? this.props.data._id : this.props.data
            }

            let choosen
            if (userId) {
                newData.forEach(oneNewData => {
                    // console.log(oneNewData.value)
                    if (oneNewData.value == userId) {
                        // console.log("OK!!!")
                        choosen = oneNewData
                        // this.setState({ choosen: oneNewData })
                        // choosen.push({ title: oneNewData.title, value: oneTitleId })
                    }
                });
            }

            if (!choosen) {
                choosen = this.valueToOption(userId)
            }

            // console.log(newData)

            // if (Array.isArray(this.props.data)) {
            //     let choosen = []
            //     this.props.data.forEach(oneTitle => {
            //         let oneTitleId = typeof oneTitle == 'object' ? oneTitle._id : oneTitle
            //         newData.forEach(oneNewData => {

            //             if (oneNewData.value == oneTitleId) {
            //                 choosen.push({ title: oneNewData.title, value: oneTitleId })
            //             }
            //         });

            //     })
            //     this.setState({ choosen })
            //     // console.log(choosen)


            // }

            this.setState({
                choosen,
                options: newData,
                parents: newParents,
                isLoading: false
            })
        })

        // }).catch(error => this.setState({ error, isLoading: false }));
    }


    spliter(source, string) {
        if (string) {
            var stringArray = string.split('.')
            var finalString = source
            stringArray.forEach(element => {
                finalString = finalString[element]
            });
        }
        return finalString
    }




    search = async (value) => {
        // console.log("SEARCH")

        // console.log(this.state.options)
        this.setState({ title: value })
        this.setState({ search: value })

        if (!this.state.isOpen) {
            this.toggleOpen()
        }

        if (value == "") {
            await this.setState({ options: this.state.tempData }, async () => {
                await this.setState({ tempData: [] })
            })
        } else {
            if (this.state.tempData.length == 0) {
                // console.log("HERE")
                await this.setState({ tempData: this.state.options }, () => {
                    // console.log(this.state.tempData)
                })
            }
            var values = []
            // var values = this.props.data.filter((e) => e.title === value)
            // console.log(this.state.tempData)
            this.state.tempData.forEach(element => {
                // console.log(element)

                if (String(element.title).toLowerCase().includes(String(value).toLowerCase())) {
                    values.push(element)
                }
            })
            // console.log(values)

            this.setState({ options: values })

            // }
        }
    }


    // removeItem(index) {
    //     // let choosen = [...this.state.choosen]
    //     // choosen.splice(index, 1)
    //     this.setState({ choosen: '' }, () => {
    //         this.changeValue()
    //     })
    // }



    changeValue() {
        // let choosen = []
        // this.state.choosen.forEach(element => {
        //     choosen.push((typeof element.value == 'object' ? element.value._id : element.value))
        //     // choosen.push((element.value))

        // });
        // console.log(choosen)
        // console.log(this.state.choosen)
        this.props.changeValue(this.props.header.key, (typeof this.state.choosen == 'object' ? this.state.choosen.value : this.state.choosen), this.props.extra, this.state.choosen)
    }

    openFilter = () => {
        this.filterModal.modal.showModal()
    }

    changeName = (key, value) => {
        this.props.changeValue('fullname', value, this.props.extra)
    }

    showVariables = () => {

        this.stagesManager.changeStage('variables')
        setTimeout(() => {
            this.fixedView.getBounding()
        }, 100);
    }

    goToMain = () => {
        this.stagesManager.changeStage('main')
        setTimeout(() => {
            this.fixedView.getBounding()
        }, 100);
    }

    useVariableValue = (key, value, extra) => {

        this.fixedView.hideView()
        // let finalValue = paramToStandardOption(this.props.params, value)

        let choosen = this.valueToOption(value)

        this.setState({ choosen }, () => {

            this.changeValue()

        })
    }

    valueToOption = (value) => {

        let [finalValue, path] = paramToStandardOption(this.props.params, value, "{{")

        let choosen = {

            title: finalValue ? (finalValue.label ?? (finalValue.name ?? finalValue?.information?.label)) : '{{lang}}Invalid!',
            value: value,
            username: finalValue?.username,
            description: finalValue?.description,
            type: finalValue?.type,
            valueType: 'variable',

            // description: "{{lang}}Variable"
        }

        return choosen
    }



    render() {

        let info = this.props.header?.information
        let disabled = this.props.header?.information?.disabled

        return (
            <div className='mt-0 w-100 h-100 flexc ' style={{ position: 'relative' }}  >

                <div ref={ref => this.setWrapperRef(ref)} className="w-100" >

                    <div className="flexcb w-100 h-100">
                        <div className="ref" ref={el => this.currentNode = el} onClick={() => { if (!disabled) { this.toggleOpen(true) } }} style={{ minWidth: 0, flex: 1, cursor: 'pointer' }}>
                            {(!this.props.data || this.props.data == '') && (
                                <div className="h-100 flexc" style={{ flex: 1 }}>
                                    <label className={' mrd-1 mld-1 placeholder py-2'}>{checkTextTranslation(this.props.header.information?.placeholder)}</label>
                                </div>
                            )}
                            {/* {!this.props.header.information?.placeholder && (!this.props.data || this.props.data == '') &&
                                <div className="h-100 flexc" style={{ flex: 1 }}>
                                    <label className={' mrd-1 mld-1 placeholder py-2'}>{checkTextTranslation('Select User...')}</label>
                                </div>
                            } */}

                            {(this.props.data && this.props.data != '') && (
                                <div className="w-100 h-100 flexc mrd-2 ">
                                    {this.state.choosen?.valueType != 'variable' && (
                                        <div className="flexcc mrd-2">
                                            <img src={imageAddress(this.state.choosen?.image, 'profile', 'small')} width="30px" style={{ border: '1px solid #eee', borderRadius: 50, height: 30, objectFit: 'cover' }} alt="" />
                                        </div>
                                    )}

                                    {this.state.choosen?.valueType == 'variable' && (
                                        <div className="flexcc br-20 " style={{ padding: 6 }}>
                                            <img src={'/assets/icons/useful/brackets-curly.svg'} width="14px" style={{ height: 14, objectFit: 'cover' }} alt="" />
                                        </div>
                                    )}


                                    <div className="flex-1" style={{ minWidth: 0 }}>
                                        {/* {!this.state.editMode ? ( */}
                                        <p className="text-small w-100" style={{ textOverflow: 'ellipsis', overflow: 'hidden', }}>{checkTranslation(this.state.choosen?.title)}</p>
                                        {/* ) : (
                                            <div className="flexc">
                                                <div className="br-4" style={{ backgroundColor: '#fff', border: '1px solid #eee' }}>
                                                    <input onChange={(e) => this.changeName(e.target.value)} className="transparent-input h-100 w-100 px-2 py-2" value={this.props.fullData?.fullname} placeholder={translate("Full name")+'*'} />
                                                </div>
                                            </div>
                                        )} */}
                                        {(!this.props.isConditionComponent && this.state.choosen?.valueType != 'variable') && (
                                            <>
                                                {(this.state.choosen?.description || this.state.choosen?.username) ? (
                                                    <p className="text-smaller" style={{ textOverflow: 'ellipsis', overflow: 'hidden', color: '#777', fontWeight: 400 }}>@{this.state.choosen?.username ?? this.state.choosen?.description}</p>
                                                ) : (
                                                    <p className={"text-smaller " + (this.state.editMode ? ' mx-2 mt-1 ' : '')} style={{ textOverflow: 'ellipsis', overflow: 'hidden', color: '#777', fontWeight: 400 }}>{translate("Virtual hub")}</p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* {this.props.header.information?.isSearchable && (
                            <button onClick={() => this.openFilter()} className="flexcc">
                                <img src="/assets/icons/useful/search.svg" height="20px" />
                            </button>
                        )} */}
                    </div>


                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: 3, right: 5 }}>
                            <Loader
                                type="Oval"
                                color="#FF6C00"
                                height="20"
                                width="20"
                            />
                        </div>
                    )}

                    {/* <div ref={el => this.positionIndicator = el} className="fix-position-indicator">

                    </div> */}

                    {/* {this.state.isOpen && ( */}
                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={10} bottomOffset={0} zIndex={5} xOffset={0} rightAlign={false} width={250}>

                        <StagesManager ref={e => this.stagesManager = e} fast={true}>

                            <div stage={0} stageName='main' className="text-start" ref={el => this.listView = el} style={{ display: 'flex', zIndex: 5, maxWidth: 300, maxHeight: 250, minWidth: 250 }}>
                                <div className={'search-drop-down '} style={{ paddingBottom: 20, display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderRadius: 8, maxHeight: this.state.maxHeight, overflow: 'auto', boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', border: '1px solid #eee' }}>
                                    {/* {this.props.header.information?.isSearchable && ( */}
                                    <div className="bg-white py-1 px-1 w-100" style={{ position: 'sticky', top: 0, zIndex: 1, }}>
                                        <input className="w-100" value={this.state.search} onChange={event => this.search(event.target.value)} placeholder={translate("useful.searchPlaceholder")} style={{ fontSize: 14, padding: '8px 10px', margin: 0, backgroundColor: '#fff', borderRadius: 4, border: '#e0e2e6 solid 1px', marginTop: 0, }} />
                                    </div>
                                    {/* )} */}



                                    {this.state.options.length != 0 && (
                                        <div className="mt-2" onClick={() => this.changeItem({ value: '' })} style={{ cursor: 'pointer', backgroundColor: 'transparent', opacity: 0.5, padding: '5px 12px' }}>
                                            <p style={{ margin: 0, color: '#456', fontSize: 13 }}>{checkTranslation(this.props.header?.information?.defaultPlaceholder ?? "{{lang}}useful.choosePlaceholder")}</p>
                                        </div>
                                    )}

                                    {info.showVariables && (
                                        <button onClick={() => this.showVariables()} className="flexcb" style={{ padding: '5px 12px' }}>
                                            <p className="text-small text-semibold" style={{ color: '#007aff' }}>{translate("Use variables")}</p>
                                            <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />
                                        </button>
                                    )}

                                    {/* {this.state.parents?.map((prop, index) => {
                                    let selectableParent = this.props.header.information?.selectableParent
                                    let selected = false
                                    return (
                                        <div key={index}>
                                            {(!this.state.search || this.state.search == '') && (
                                                <div onClick={() => { if (selectableParent) this.changeItem(prop, selected) }} style={{ padding: '10px 20px', borderBottom: '1px solid #eee', marginBottom: 5, cursor: selectableParent ? 'pointer' : '' }}>
                                                    <p style={{ margin: 0, color: '#789', fontSize: 13 }}>{prop.title}</p>
                                                </div>
                                            )} */}
                                    {this.state.options?.map((cprop, cindex) => {
                                        let cselected = false

                                        // if (cprop.parent == prop.value) {
                                        return (
                                            <div className="" key={cprop.value}>
                                                <div className="flexc " key={cindex} onClick={() => this.changeItem(cprop, cselected)} style={{ cursor: 'pointer', backgroundColor: cselected ? '#f7f7f7' : '#transparent', padding: '5px 12px' }}>
                                                    {this.props.header.information?.fields?.image && (
                                                        <div className="flexcc">
                                                            <img className="mrd-3" src={imageAddress(cprop.image, 'profile', 'small')} width="30px" height="30px" alt="" style={{ borderRadius: 40, objectFit: 'cover' }} />
                                                        </div>
                                                    )}
                                                    <div className="d-flex flex-column justify-content-center">
                                                        <p className="text-semibold" style={{ margin: 0, color: '#000', fontSize: 13 }}>{checkTranslation(cprop.title)}</p>
                                                        {(cprop.description || cprop.username) ?
                                                            (
                                                                <p style={{ margin: 0, color: '#789', fontSize: 12, lineHeight: 1.2 }}>@{checkTranslation(cprop.username ?? cprop.description)}</p>
                                                            ) : (
                                                                <p style={{ margin: 0, color: '#789', fontSize: 12, lineHeight: 1.2 }}>{translate("Virtual hub")}</p>
                                                            )}

                                                    </div>
                                                </div>
                                            </div>
                                        )
                                        // }
                                    })}
                                    {/* </div> */}
                                    {/* )
                                })} */}

                                    {this.state.options.length == 0 && (
                                        <div className="px-2 pt-3">
                                            <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("useful.foundNothing")}</p>
                                            {/* {this.props.header.information?.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)} */}

                                        </div>
                                    )}

                                </div>
                            </div>


                            <div stage={1} stageName='variables' style={{ display: 'flex', zIndex: 5, maxWidth: 300, maxHeight: 250, minWidth: 250 }} >

                                <div className={'h-100'} style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderRadius: 8, maxHeight: this.state.maxHeight, overflow: 'auto', boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', border: '1px solid #eee' }}>

                                    <div className="scroll-no-scrollbar h-100" style={{ maxHeight: '200px' }}>

                                        <ParamsListItems data={this.state.choosen?.valueType == 'variable' ? this.state.choosen?.value : null} params={this.props.params} goToMain={this.goToMain} changeValue={this.useVariableValue} hasPreviousPage={true} validTypes={info.validTypes} variables={this.props.variables} variableIndicatior={"{{"} />

                                    </div>

                                </div>
                            </div>


                        </StagesManager>
                    </FixedView>
                    {/* )} */}

                </div>
                {/* {this.props.header.information?.search && ( */}
                {/* <FilterModal ref={el => this.filterModal = el} headers={this.props.header.information?.search?.headers} initData={this.state.filter} /> */}
                {/* )} */}

            </div>
        );
    }
}


export default GlobalUserInput;
